import React, { useState } from "react";
import BB from "./Images/BB.png";
import { Menu, X, ChevronRight, Truck, LogOut, Headphones } from "lucide-react";
import { decryptData } from "../utils/storageCrypto";
import { theme } from "../assets/theme/theme";
import HelpSupportModal from "./components/HelpSupport";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [showSupport, setShowSupport] = useState(false);
  const enMobile = sessionStorage.getItem("mobile");
  const mobile = decryptData(enMobile);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/delivery";
  };

  return (
    <>
      <nav
        className="relative bg-white border-b shadow-xs z-40"
        style={{
          borderColor: theme.colors.grey002,
          backgroundColor: theme.colors.pureWhite,
        }}
      >
        {/* Top Bar */}
        <div className="max-w-md mx-auto flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <img src={BB} alt="Brickbucket" className="h-8 w-auto object-contain" />
          </div>

          <button
            type="button"
            onClick={() => setOpen(!open)}
            className="w-9 h-9 rounded-xl border flex items-center justify-center transition-all active:scale-95 cursor-pointer"
            style={{
              backgroundColor: open ? theme.colors.grey001 : theme.colors.offWhite,
              borderColor: theme.colors.grey005,
              color: theme.colors.bitumen,
            }}
            aria-label="Toggle Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>

        {/* Dropdown Menu */}
        {open && (
          <div
            className="absolute top-full left-0 w-full bg-white border-b shadow-lg z-50 animate-slideDown"
            style={{ borderColor: theme.colors.grey005 }}
          >
            <div className="max-w-md mx-auto px-4 py-4 space-y-3">
              <p
                className="text-[11px] uppercase font-bold tracking-wider"
                style={{
                  fontFamily: "DMSans-Medium",
                  color: theme.colors.concrete,
                }}
              >
                Hello, {mobile ? `+91 ${mobile}` : "Delivery Partner"}
              </p>

              {/* 1. Trips Option */}
              <button
                type="button"
                onClick={() => {
                  setOpen(false);
                  window.location.href = `/delivery/rides?mobile=${mobile}`;
                }}
                className="w-full p-3 rounded-2xl border flex items-center justify-between transition-all active:scale-[0.99] cursor-pointer hover:bg-gray-50"
                style={{
                  backgroundColor: theme.colors.pureWhite,
                  borderColor: theme.colors.grey005,
                }}
              >
                <div className="flex items-center gap-3">
                  <div
                    className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
                    style={{
                      backgroundColor: `${theme.colors.brand}15`,
                      color: theme.colors.brand,
                    }}
                  >
                    <Truck className="w-4 h-4" />
                  </div>
                  <div className="text-left">
                    <p
                      className="text-xs font-bold leading-tight"
                      style={{
                        fontFamily: "DMSans-SemiBold",
                        color: theme.colors.bitumen,
                      }}
                    >
                      Trips
                    </p>
                    <p className="text-[10px] text-gray-400 mt-0.5">
                      View assigned and available rides
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-gray-400" />
              </button>

              {/* 2. Help & Support Option */}
              <button
                type="button"
                onClick={() => {
                  setOpen(false);
                  setShowSupport(true);
                }}
                className="w-full p-3 rounded-2xl border flex items-center justify-between transition-all active:scale-[0.99] cursor-pointer hover:bg-gray-50"
                style={{
                  backgroundColor: theme.colors.pureWhite,
                  borderColor: theme.colors.grey005,
                }}
              >
                <div className="flex items-center gap-3">
                  <div
                    className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
                    style={{
                      backgroundColor: `${theme.colors.bitumen}10`,
                      color: theme.colors.bitumen,
                    }}
                  >
                    <Headphones className="w-4 h-4" />
                  </div>
                  <div className="text-left">
                    <p
                      className="text-xs font-bold leading-tight"
                      style={{
                        fontFamily: "DMSans-SemiBold",
                        color: theme.colors.bitumen,
                      }}
                    >
                      Help & Support
                    </p>
                    <p className="text-[10px] text-gray-400 mt-0.5">
                      Contact helpline & report issues
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-gray-400" />
              </button>

              {/* 3. Logout Option */}
              <button
                type="button"
                onClick={handleLogout}
                className="w-full p-3 rounded-2xl border flex items-center justify-between transition-all active:scale-[0.99] cursor-pointer hover:bg-red-50"
                style={{
                  backgroundColor: "#FEF2F2",
                  borderColor: "#FEE2E2",
                }}
              >
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-red-100 text-red-600 shrink-0">
                    <LogOut className="w-4 h-4" />
                  </div>
                  <div className="text-left">
                    <p
                      className="text-xs font-bold leading-tight text-red-600"
                      style={{ fontFamily: "DMSans-SemiBold" }}
                    >
                      Logout
                    </p>
                    <p className="text-[10px] text-red-400 mt-0.5">
                      End current session
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-red-400" />
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Support Drawer Modal */}
      <HelpSupportModal
        isOpen={showSupport}
        onClose={() => setShowSupport(false)}
      />
    </>
  );
};

export default Navbar;